
import DefaultController from '../controller';
import {createObjectFromDefault} from '../functions';

class Path extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'path';

    }

    
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Path,
    properties: {   },
    events: {   },
    children: []
}

export default Blueprint;
export {Path as Controller, Blueprint};
